import type { BreadcrumbItem } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import type { EndpointRegistrationKey } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { repository } from "~/clientInstance";
import endpointRegistry from "../MachineSettings/Endpoints/endpointRegistry";
import { DiscoverWorkerOrDeploymentTargetPage } from "./DiscoverWorkerOrDeploynentTargetPage";
interface DeploymentTargetDiscoveryPageProps {
    spaceId: string;
    environmentId?: string;
    endpointKey: EndpointRegistrationKey;
}
export function DiscoverDeploymentTargetPage({ spaceId, environmentId, endpointKey }: DeploymentTargetDiscoveryPageProps) {
    const registration = endpointRegistry.getMachine(endpointKey);
    const title = `Create ${registration ? registration.name : "deployment target"}`;
    const breadcrumbItems: BreadcrumbItem[] = [
        {
            label: "New Deployment Target",
            pageUrl: environmentId ? links.selectDeploymentTargetTypePage.generateUrl({ spaceId }, { environmentId }) : links.selectDeploymentTargetTypePage.generateUrl({ spaceId }),
        },
    ];
    const discover = (host: string, port: number, type: {}, proxyId: string | undefined) => repository.Machines.discover(host, port, type, proxyId);
    return (<DiscoverWorkerOrDeploymentTargetPage title={title} machineTypeDescription={"deployment target"} createLink={links.addDeploymentTargetPage} discover={discover} breadcrumbItems={breadcrumbItems} endpointKey={endpointKey} environmentId={environmentId} spaceId={spaceId}/>);
}
